import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pb-code',
    templateUrl: './pb-code.component.html',
    styleUrls: ['./pb-code.component.scss']
})
export class PbCodeComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            var item = {
                content: element.data,
                type: element.item.type,
                alignment: this.determineAlignment(element.alignment),
                flexAlignment: this.determineFlexAlignment(element.alignment),
            }

            this.items.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineFlexAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'justify-content-start';
        } else if (alignment == 'CENTER') {
            return 'justify-content-center';
        } else if (alignment == 'RIGHT') {
            return 'justify-content-end';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

}
